import theme from '../themes/phoenix/theme';

type BreakpointSize = 'sm' | 'md' | 'lg' | 'xl';

const breakpoint = (size: BreakpointSize) => (content: string) => `
  @media only screen and (min-width: ${theme.breakpoints[size]}) {
    ${content};
  }
`;

export default breakpoint;
